import { inject, injectable } from 'inversify';

import { TemplatePermission } from '../models/restrictions.model';
import { IRestrictionsRepository } from '../repositories/restrictions.repository';
import { TYPES } from '../restrictions.types';
import { RestrictionsStoreInjector } from '../store/restrictions.store';

export interface IRestrictionsFacade {
  templateRestriction: Record<string, boolean>;
  loadTemplatePermissions(templateId: number): Promise<void>;
}

@injectable()
export class RestrictionsFacade implements IRestrictionsFacade {
  constructor(
    @inject(TYPES.RestrictionsRepository)
    private readonly repository: IRestrictionsRepository,
    @inject(TYPES.RestrictionsStore)
    private readonly store: RestrictionsStoreInjector
  ) {}

  private get state() {
    return this.store.getState();
  }

  public get templateRestriction() {
    return this.state.template.permissions;
  }

  public async loadTemplatePermissions(templateId: number): Promise<void> {
    try {
      const templatePermissions = await this.repository.fetchTemplatePermissions(templateId);

      this.state.template.setRestrictions(templatePermissions[0] as unknown as TemplatePermission);
    } catch (error) {
      console.error('Error loading template permissions:', error);
    }
  }
}
